import React from 'react';
import { Link } from 'react-router-dom';
import { ktpTypes } from '../../types/ktp';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../../components/forms/ContactForm';
import RelatedCategories from '../../components/catalog/RelatedCategories';

// НОВЫЙ КОМПОНЕНТ KtpPageHero для страницы списка КТП
const KtpPageHero: React.FC = () => {
  return (
    <section className="relative overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0 min-h-[70vh]">
        <video autoPlay muted loop playsInline className="w-full h-full object-cover">
          <source src="/videos/0605.mp4" type="video/mp4" /> {/* Видео для списка КТП */}
          Ваш браузер не поддерживает видео.
        </video>
        {/* Overlay */}
        <div className="absolute inset-0 bg-primary-900/40"></div>
      </div>

      {/* Content */}
      <div className="container-custom relative z-10 pt-16 pb-16 md:pb-24 lg:pb-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          {/* Left column: Text content */}
          <div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight text-white">
              Комплектные трансформаторные подстанции от Проминнова – надежность и адаптивность для
              вашего проекта
            </h1>

            <p className="text-xl md:text-2xl text-primary-100 mb-8">
              Производство любых типов подстанций под потребности и ТЗ заказчика, индивидуальные
              решения и быстрая поставка.
            </p>

            {/* Особенности КТП - Можете адаптировать иконки/текст */}
            {/* ... например, можно добавить особенности, общие для всех КТП ... */}

            {/* Кнопки - Можете адаптировать */}
            <div className="flex flex-wrap items-center gap-4">
              {/* Пример кнопки "Смотреть типы КТП" */}
              {/* <Link to="/catalog/ktp#types" className="btn-primary inline-flex items-center group">
                Типы КТП
                 <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </Link> */}
              {/* Пример кнопки "Получить консультацию" */}
              {/* <Link to="/contact" className="text-white hover:text-primary-200 font-medium inline-flex items-center transition-colors">
                Получить консультацию
                 <ArrowRight className="ml-1 w-4 h-4" />
              </Link> */}
            </div>
          </div>

          {/* Right column: Form - Оставляем форму заявки */}
          <div>
            <div className="bg-white text-gray-900 rounded-xl shadow-xl overflow-hidden">
              <div className="p-6">
                <h3 className="text-xl font-semibold mb-2">Оставьте заявку</h3>
                <p className="text-gray-600 mb-6">
                  Заполните форму, и наш менеджер свяжется с вами в течение 2 часов (в рабочее
                  время).
                </p>
                <ContactForm /> {/* Используем существующий компонент формы */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const KtpPage: React.FC = () => {
  const mainTypes = ['ktpn', 'ktpnu', 'ktp'];
  const secondaryTypes = ['bktp', 'ktpp', 'ktps'];

  return (
    <div>
      <Helmet>
        <title>Комплектные трансформаторные подстанции | Пром Инновации</title>
        <meta
          name="description"
          content="Производство и поставка комплектных трансформаторных подстанций различных типов. Индивидуальные решения под ваши задачи."
        />
      </Helmet>

      {/* Добавляем новый Hero блок для страницы списка КТП */}
      <KtpPageHero />

      {/* Остальное содержимое страницы списка КТП */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {mainTypes.map((type) => {
            const ktp = ktpTypes[type];
            return (
              <Link
                key={ktp.id}
                to={`/catalog/ktp/${ktp.id}`}
                className="group bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="aspect-[4/3] bg-gray-200">
                  <img
                    src={ktp.image_url}
                    alt={ktp.title}
                    className="w-full h-full object-contain"
                    loading="lazy"
                    width="400"
                    height="300"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600">
                    {ktp.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2">{ktp.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {ktp.features.slice(0, 2).map((feature, index) => (
                      <span key={index} className="text-sm bg-gray-100 px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {secondaryTypes.map((type) => {
            const ktp = ktpTypes[type];
            return (
              <Link
                key={ktp.id}
                to={`/catalog/ktp/${ktp.id}`}
                className="group bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="aspect-[4/3] bg-gray-200">
                  <img
                    src={ktp.image_url}
                    alt={ktp.title}
                    className="w-full h-full object-contain"
                    loading="lazy"
                    width="400"
                    height="300"
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-xl font-semibold mb-2 group-hover:text-blue-600">
                    {ktp.title}
                  </h3>
                  <p className="text-gray-600 mb-4 line-clamp-2">{ktp.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {ktp.features.slice(0, 2).map((feature, index) => (
                      <span key={index} className="text-sm bg-gray-100 px-2 py-1 rounded">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            );
          })}
        </div>

        <RelatedCategories currentCategory="ktp" />
      </div>
    </div>
  );
};

export default KtpPage;
